import logo from './logo.svg';
import './App.css';
import MainPage from './components/MainPage';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <MainPage/>
  );
}

export default App;
